import { VENUES } from "@/config/contracts";
import type { Section } from "@/hooks/use-path-route";

import { ConnectButton } from "./connect-button";
import { MooseMark } from "./moose-mark";
import { SectionNav } from "./section-nav";

type Props = {
  readonly section: Section;
  readonly onSection: (s: Section) => void;
};

const ExternalIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    aria-hidden
    className="inline-block ml-1.5"
    style={{ verticalAlign: "baseline", color: "var(--ink-4)" }}
  >
    <path
      d="M3 1.5h5.5V7M8.5 1.5L4 6M4 1.5H1.5v7h7V6"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExternalLink = ({
  href,
  label,
}: {
  readonly href: string;
  readonly label: string;
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="font-sans text-[12px] tracking-[0.12em] uppercase hidden lg:inline-block transition-opacity hover:opacity-70"
    style={{ color: "var(--ink-3)" }}
  >
    {label}
    <ExternalIcon />
  </a>
);

export const Header = ({ section, onSection }: Props) => (
  <header className="relative z-10 px-6 md:px-12 py-5 md:py-7">
    <div className="max-w-[1240px] mx-auto flex flex-wrap items-center gap-y-4 md:flex-nowrap md:items-baseline md:justify-between">
      <div className="flex items-baseline gap-3 shrink-0">
        <MooseMark size={34} className="shrink-0 self-center" />
        <div className="flex items-baseline gap-3">
          <span
            className="font-serif text-[28px] tracking-tight"
            style={{ fontWeight: 300 }}
          >
            cadc
          </span>
          <span
            className="font-mono text-[10px] tracking-[0.18em] uppercase"
            style={{ color: "var(--ink-3)" }}
          >
            / looper
          </span>
        </div>
      </div>

      {/* On mobile this drops to its own full-width row below; on md+ it sits
          centered between the brand and the nav. */}
      <div className="order-last w-full flex justify-center md:order-none md:w-auto md:flex-1">
        <SectionNav value={section} onChange={onSection} />
      </div>

      <nav className="flex items-center gap-6 md:gap-10 ml-auto md:ml-0 shrink-0">
        <ExternalLink href={VENUES.morpho.href} label="Morpho" />
        <ExternalLink href={VENUES.ajna.href} label="Ajna" />
        <ExternalLink
          href="https://aerodrome.finance/swap?from=0x833589fcd6edb6e08f4c7c32d4f71b54bda02913&to=0x043eb4b75d0805c43d7c834902e335621983cf03&chain0=8453&chain1=8453"
          label="Aerodrome"
        />
        <ConnectButton />
      </nav>
    </div>
  </header>
);
